export default __webpack_public_path__ + "static/media/list-program.d21e1bcf.svg";